import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const BoligRaadgivning = () => {
  const topics = [
    "Valg af lånetype (fast vs. variabel rente)",
    "Korrekt brug af afdragsfrihed",
    "Konsekvensberegning ved boligkøb",
    "Omlægning af eksisterende lån",
    "Valg af finansieringsinstitut",
    "Skattemæssige konsekvenser ved lånevalg"
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Boligøkonomi: Finansiering af din bolig</title>
        <meta name="description" content="Finansoptimering rådgiver og hjælper dig med hele din boligøkonomi. Sammen finder vi den mest optimale finansiering af din bolig. Se mere her." />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Rådgivning til boligøkonomi</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Rådgivning til boligøkonomi</h1>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <h2 className="text-2xl font-bold text-slate-900 mb-6">De rigtige beslutninger til din bolig</h2>
          <p>
            Valg af boligform og finansiering er en af de vigtigste økonomiske beslutninger i livet. Vi hjælper dig med at træffe det rigtige valg baseret på din tidshorisont og dine økonomiske forhold.
          </p>
          <p>
            Uanset om du skal købe ny bolig eller optimere din nuværende finansiering, sikrer vi, at din boligøkonomi er skruet rigtigt sammen fra start.
          </p>
        </div>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200 mb-12">
          <h3 className="text-xl font-bold text-slate-900 mb-8">
            Vi rådgiver blandt andet om:
          </h3>
          <ul className="space-y-4 mb-10">
            {topics.map((topic, i) => (
              <li key={i} className="flex items-start">
                <CheckCircle2 size={20} className="text-[#b60f00] mr-4 shrink-0 mt-1" />
                <span className="text-slate-700 leading-relaxed">{topic}</span>
              </li>
            ))}
          </ul>
          
          <div className="text-center">
            <Link 
              to="/kontakt-os" 
              className="inline-flex items-center bg-[#b60f00] text-white px-10 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md active:scale-95"
            >
              Bestil et gratis uforpligtende møde her
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoligRaadgivning;
